import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueDOMPurifyHTML from 'vue-dompurify-html'

createApp(App)
  .use(store)
  .use(router)
  .use(VueDOMPurifyHTML)
  .mount('#app')
